import { userLogout as logout } from "../services/auth";
import { logoutSegmentEvent } from "./segmentEventHandler";
import { getUserToken, removeAllLocalStorageData, removeUser } from "./user";

const checkAuth = () => {
  return getUserToken();
};

const setLoggedInUser = () => {};

const getLoggedInUser = () => {};

const userLogout = (navigate) => {
  const authToken = getUserToken();
  logout(authToken)
    .then((response) => {
      removeUser()
        .then((response) => {
          removeAllLocalStorageData();
          logoutSegmentEvent();
          if (navigate) {
            navigate("/login?type=mobile");

            return;
          }
          window.location.reload();
        })
        .catch((error) => {
          console.log(error);
        });
    })
    .catch((error) => {});
};

export { checkAuth, setLoggedInUser, getLoggedInUser, userLogout };
